import React from 'react'

export default function Heading({ Heading, className }) {
    return (
        <div> <h2 className={`heading ${className}`}>{Heading}</h2></div>
    )
}
